export const BASE_URL = 'https://api.ulixes.app';
export const API_BASE_URL = BASE_URL + '/api';
export const USER_TOKEN = 'userToken';
export const USER = 'user';
export const STATS_CACHE_KEY = 'ulixes_stats_cache';
export const CACHE_DURATION = 24 * 60 * 60 * 1000;
export const COUNTRIES = "cached_country_data";

export const endpoints = {
    register: '/register',
    login: '/login',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    update: '/info',
    user: '/user',
    saveGuide: (id: number) => { return `/guides/${id}/save` },
    options: '/options',
    guides: '/guides',
    publicGuides: '/guides/public',
    googleLogin: '/google/login',
    googleRegister: '/google/register',
    paymentPackages: '/payment/packages',
    paymentProcess: '/payment/process',
    paymentIntent: '/payment/intent',
    stats: '/stats',
    countries: '/countries',
    cities: (countryCode: string) => `/cities/${countryCode}`,
};
